var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.getters.forgetFlow.show,
            expression: "$store.getters.forgetFlow.show"
          }
        ],
        staticClass: "forget",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            _vm.close($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "forget-container" },
          [
            _c("p", { staticClass: "form-header" }, [
              _c("i", {
                staticClass: "iconfont icon-cancel",
                on: { click: _vm.close }
              })
            ]),
            _vm._v(" "),
            _vm.$store.getters.forgetFlow.type === "email"
              ? _c("email-form")
              : _vm.$store.getters.forgetFlow.type === "mobile"
                ? _c("phone-form", { on: { updateInfo: _vm.updateInfo } })
                : _c("passwd-form")
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-019343bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019343bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Public/Forget.vue
// module id = null
// module chunks = 